// @flow

import React, { Component } from 'react';
import {Icon} from 'react-fa';
import _ from 'lodash';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import {saveAs} from 'file-saver';
import * as ExcelJs from 'exceljs/dist/es5/exceljs.browser';

import type { Element } from 'react';

import App from './App.jsx';
import Map from './Map.jsx';
import XDialog from './XDialog.jsx';

import {inv_ord, gen_snum, show_dir, abrev, service_name, takeFilename} from './utils.js';


import type {T_ReportEntry, T_ColOrd} from './types.js';

import './css/DialogReport.css';



type T_DialogReportProps = {
  entries     : Array<T_ReportEntry>,
  app         : App,
  num_decimals: number,
  path        : string
};


type T_ReportEntryState = {
  show       : boolean,
  active     : number,
  st_col_ord : ?T_ColOrd,
  restrict_to: Array<string>,
};



export default class DialogReport extends Component<T_DialogReportProps, T_ReportEntryState> {
  tr_hilight: ?any; // WAS: Element<string>;
  markers   : Array<?Object>;
  
  click_col_sort: (ev: SyntheticInputEvent<*>)     => void;
  click_row     : (ev: SyntheticEvent<*> | number) => void;
  get_excel     : () => void;
  get_full_excel: () => void;
  zoom_all_marks: () => void;
  
  
  constructor(props: T_DialogReportProps) {
    super(props);
    
    this.state = {
      show       : true,
      active     : -1,
      st_col_ord : null,
      restrict_to: []
    };
    
    this.markers = [];
    
    this.click_col_sort = this.click_col_sort.bind(this);
    this.click_row      = this.click_row.bind(this);
    this.get_excel      = this.get_excel.bind(this);
    this.get_full_excel = this.get_full_excel.bind(this);
    this.zoom_all_marks = this.zoom_all_marks.bind(this);
    
    this.props.app.dialog_report = this;
  }
  
  
  
  componentDidMount() {
    this.show_on_map();
  }
  
  
  
  componentWillUnmount() {
    this.remove_marks();
    
    this.props.app.dialog_report = null;
  }
  
  
  
  componentDidUpdate(prevProps: T_DialogReportProps, prevState: T_ReportEntryState) {
    if (prevState.show && ! this.state.show) {
      this.props.app.setState({
        report_entries: {entries: [], path: ''}
      });
    }
    
    if ((! _.isEqual(prevProps.entries, this.props.entries)) || (! _.isEqual(prevState.restrict_to, this.state.restrict_to))) {
      this.show_on_map();
    }
  }
  
  
  
  remove_marks(): void {
    this.markers.forEach((marker) => {
      if (marker != null) {
        marker.setMap(null);
      }
    });
    
    this.markers = [];
  }
  
  
  
  zoom_all_marks(): void {
    if (this.markers.length === 0) {
      return;
    }
    
    if (Map.google != null) {
      const bounds = new Map.google.LatLngBounds();
      
      this.markers.forEach((marker) => {
        if (marker != null) {
          bounds.extend(marker.getPosition());
        }
      });
      
      this.props.app.map_ui.map.map.fitBounds(bounds);
    }
  }
  
  
  
  show_on_map(): void {
    this.remove_marks();
    
    this.markers = this.get_entries().map((entry) => {
      return this.props.app.map_ui.map.put_marker(entry.Lat, entry.Long, () => {
        if (this.props.app.tree != null) {
          this.props.app.tree.open_path(entry.Path, (item_dir) => {
            this.hilight_row(entry.Path);
          });
        }
      });
    });
    
    this.zoom_all_marks();
  }
  
  
  
  hilight_row(path: string): void {
    this.setState({active: _.findIndex(this.custom_sort(this.get_entries()), entry => entry.Path === path)}, () => {
      if (this.tr_hilight != null) {
        if (this.tr_hilight.scrollIntoViewIfNeeded && typeof this.tr_hilight.scrollIntoViewIfNeeded === 'function') {
          this.tr_hilight.scrollIntoViewIfNeeded();
        }
        else {
          scrollIntoViewIfNeeded(this.tr_hilight);
        }
      }
    });
  }
  
  
  
  click_col_sort(ev: SyntheticInputEvent<*>): void {
    const {col} = ev.target.dataset;
    
    this.setState({
      st_col_ord: {
        col,
        ord: this.state.st_col_ord && this.state.st_col_ord.col === col ? inv_ord(this.state.st_col_ord.ord) : 'sort-asc'
      }
    });
  }
  
  
  
  toggle_sort(col: string, show?: string): Element<string> {
    const data_col = {'data-col': col};
    
    return (
      <a {...data_col} onClick={this.click_col_sort}>
        {(this.state.st_col_ord && this.state.st_col_ord.col === col) &&
          <Icon name={this.state.st_col_ord.ord} />
        }
        {show || col}
      </a>
    );
  }
  
  
  
  get_total_has(): number {
    return _.sumBy(this.props.entries, entry => entry.Area);
  }
  
  
  
  custom_sort(rows: Array<Object>): Array<Object> {
    if (! this.state.st_col_ord) {
      return rows;
    }
    
    const rs = _.sortBy(rows, this.state.st_col_ord.col);
    
    return this.state.st_col_ord != null && this.state.st_col_ord.ord === 'sort-desc' ? _.reverse(rs) : rs;
  }
  
  
  
  click_row(ev: SyntheticEvent<*>): void {
    const {dataset} = ev.currentTarget;
    
    this.setState({active: parseInt(dataset.num, 10)}, () => {
      if (this.props.app.tree != null) {
        this.props.app.tree.open_path(dataset.path, (item_dir) => {});
      }
    });
  }
  
  
  
  excel_reporte(path: string, entries: Array<T_ReportEntry>): void {
    const workbook  = new ExcelJs.Workbook(),
          excelFile = `Reporte_${takeFilename(path)}.xls`,
          worksheet = workbook.addWorksheet('Reporte de predios'),
          style     = {alignment: {vertical: 'middle'}},
          snum      = gen_snum(this.props.app.state.num_decimals);
    
    worksheet.columns = [
      {key: 'programa'  , style},
      {key: 'agricultor', style},
      {key: 'predio'    , style},
      {key: 'especies'  , style},
      {key: 'area'      , style},
      {key: 'servicio'  , style},
      {key: 'fecha'     , style},
      {key: 'num_pts'   , style}
    ];
    
    worksheet.addRow({
      programa  : 'Programa'  ,
      agricultor: 'Agricultor',
      predio    : 'Predio'    ,
      especies  : 'Especies'  ,
      area      : 'Área (has)',
      servicio  : 'Servicio'  ,
      fecha     : 'Fecha'     ,
      num_pts   : 'Num Pts'
    });
    
    entries.forEach((dd, kk) => {
      worksheet.addRow({
        programa  : show_dir(dd.Programa),
        agricultor: show_dir(dd.Agricultor),
        predio    : show_dir(dd.Predio),
        especies  : dd.Especies.join(', '),
        area      : snum(dd.Area),
        servicio  : dd.Servicio,
        fecha     : dd.Periodo,
        num_pts   : dd.MS_pts
      });
    });
    
    worksheet.getRow(1).eachCell((cell, rowNumber) => {
      cell.font = {bold: true, name: 'Arial'};
    });
    
    worksheet.eachRow((row, rowNumber) => {
      row.height = 25;
      
      row.eachCell((cell, cellNumber) => {
        const even = cell._row._number % 2 === 0;
        
        cell.fill = {
          type   : 'pattern',
          pattern: 'solid',
          fgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')},
        };
        
        if (cell._column._number === 5) {
          cell.alignment = {vertical: 'middle', horizontal: 'right'};
        }
        
        cell.border = {
          left: {style: 'thin', color: {argb: 'FFAAAAAA'}},
        };
      });
    });
    
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer],{type:"application/octet-stream"}), excelFile);
    });
  }
  
  
  
  get_excel(): void {
    this.excel_reporte(this.props.path, this.props.entries);
  }

  get_full_excel(): void {
    console.log(this.props.path, this.props.entries);
  }
  
  
  
  match(entry: T_ReportEntry): boolean {
    return _.some(this.state.restrict_to, dir => entry.Path.indexOf(dir) === 0);
  }
  
  
  
  get_entries(): Array<T_ReportEntry> {
    if (this.state.restrict_to.length === 0) {
      return this.props.entries;
    }
    else {
      return this.props.entries.filter(entry => this.match(entry));
    }
  }
  
  
  
  render() {
    const tt     = `Reporte de predios ${takeFilename(this.props.path)}`,
          st     = {width: 545, height: 276},
          st_sef = {width: 545, height: 297},
          ff     = {font: this.props.app.favorite_font()},
          snum   = gen_snum(this.props.num_decimals),
          is_sef = this.props.path.includes('sefinsa');
    
    return (
      <XDialog name='dreport' title={tt} father={this} state_ctl='show' drag={false} style={is_sef ? st_sef : st} {...ff}>
        <table className='report_table'>
          <thead>
            <tr>
              <th>{this.toggle_sort('Agricultor'  )}</th>
              <th>{this.toggle_sort('Predio'      )}</th>
              <th>{this.toggle_sort('Servicio'    )}</th>
              <th>{this.toggle_sort('Periodo'     )}</th>
              <th>{this.toggle_sort('Area', 'Área')}</th>
            </tr>
          </thead>
          
          <tfoot>
            {is_sef ?
              <tr>
                <td>
                  <a onClick={this.get_excel}>
                    Descargar excel
                  </a>
                </td>
                <td>
                  <a onClick={this.get_full_excel}>
                    Descargar Estadísticas
                  </a>
                </td>
                <td>
                  <a onClick={this.zoom_all_marks}>
                    Ver todos
                  </a>
                </td>
                <td>Total</td>
                <td>{snum(this.get_total_has())}</td>
              </tr>
             :
              <tr>
                <td>
                  <a onClick={this.get_excel}>
                    Descargar excel
                  </a>
                </td>
                <td>
                  <a onClick={this.zoom_all_marks}>
                    Ver todos
                  </a>
                </td>
                <td />
                <td>Total</td>
                <td>{snum(this.get_total_has())}</td>
              </tr>
            }
          </tfoot>
          
          <tbody>
            {this.custom_sort(this.get_entries()).map((row: T_ReportEntry, index: number) => {
              const color = index === this.state.active ? '#d9edf7' : 'white',
                    ref   = {},
                    num   = {'data-num' : index},
                    path  = {'data-path': row.Path};
              
              if (color !== 'white') {
                ref.ref = tr_hilight => this.tr_hilight = tr_hilight;
              }
              
              return (
                <tr key={index} {...ref} style={{backgroundColor: color}} {...num} {...path} onClick={this.click_row}>
                  <td>{    abrev(show_dir(row.Agricultor), 13)}</td>
                  <td>{    abrev(show_dir(row.Predio    ), 13)}</td>
                  <td>{abrev(service_name(row.Servicio),   10)}</td>
                  <td>{             abrev(row.Periodo  ,   10)}</td>
                  <td>{             snum (row.Area           )}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </XDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DialogReport.jsx